const map = {
	"./cleric_cross.webp": 63602,
	"./lovers_rose.webp": 36016,
	"./merlin_hat.webp": 49272,
	"./plot-cards/ambush.webp": 59865,
	"./plot-cards/areYouTheOne.webp": 26581,
	"./plot-cards/charge.webp": 32073,
	"./plot-cards/kingReturns.webp": 24657,
	"./plot-cards/leadToVictory.webp": 65376,
	"./plot-cards/restoreHonor.webp": 20975,
	"./plot-cards/showNature.webp": 84075,
	"./plot-cards/showStrength.webp": 97541,
	"./plot-cards/weFoundYou.webp": 8922,
	"./tiara.webp": 50444
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55072;